/*=========================================================================================
  File Name: moduleMerchant.js
  Description: Partner Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleMerchantState.js";
import mutations from "./moduleMerchantMutations.js";
import actions from "./moduleMerchantActions.js";
import getters from "./moduleMerchantGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
